import { createElement, lazy } from 'react';

// React.lazy garde pour toujours un import rejeté : après une coupure réseau ou
// un déploiement (noms de chunks changés), chaque rendu relancerait la même
// erreur jusqu'au rechargement de la page. Ici, un échec remplace le composant
// paresseux par un neuf : « Réessayer » (ou le visuel suivant) retélécharge le
// chunk, comme loadECharts.
export function retryableLazy(factory) {
  const load = () =>
    factory().catch((error) => {
      current = lazy(load);
      throw error;
    });
  let current = lazy(load);
  function RetryableLazy(props) {
    return createElement(current, props);
  }
  return RetryableLazy;
}
